<template>
  <div>
    <section id="content01">
      <Header/>
      <section id="content02" class="inner box_question">
        <h2>Q2</h2>
        <p class="txt">好きなテイストの写真を<span>3つ</span>お選びください</p>
        <ul class="lst_question_photo">
          <li v-for="(q,index) in question" :key="q.id">
            <label v-bind:class="{'select': activeItem[index]}">
              <input type="checkbox" :value="q.id" :disabled="isActive" v-model="checkedQuest">
              <img v-bind:src="q.img" v-on:click="onActive(q.id)">
            </label>
          </li>
        </ul>
        <ul class="box_btn_select">
          <li><button :disabled="!isActive" class="btn_next" v-on:click="next('q3')">次へ</button></li>
          <li><button class="btn_clear" v-on:click="clear()">クリア</button></li>
        </ul>
      </section>
    </section>
    <Footer/>
  </div>
</template>
<script>
// @ is an alias to /src
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer_quest.vue'

export default {
  name: 'Q2',
  components: {
    Header,
    Footer
  },
  data:function(){
    return{
      checkedQuest:[],
      isActive:false,
      activeItem:{
        Boolean
      },
      addpoint:null
    }
  },
  computed: {
    question: function(){
      return this.$store.getters.question02
    }
  },
  methods: {
    next: function(event){
      let name = 2
      let obj = this.addpoint
      //this.$store.commit('incrementPoint',obj)
      this.$store.commit('answerPoint',{obj,name})
      this.$router.push(event)
    },
    onActive:function(id){
      if(!this.isActive){
        if(this.activeItem[id]){
          this.activeItem[id] = false
        }else{
          this.activeItem[id] = true
        }
      }
    },
    clear:function(){
      this.checkedQuest = []
      this.isActive = false
      for( let key in this.activeItem ){
        this.activeItem[key] = false
      }
    }
  },
  watch:{
    checkedQuest: function(newVal,oldVal){
      let obj = []
      newVal.forEach(function(value){
        let Val = {
          id:value,
          val:5
        }
        obj.push(Val)
      })
      this.addpoint = obj
      if(newVal.length === 3){
        this.isActive = true
      }else{
        this.isActive = false
        oldVal;
      }
    }
  }
}
</script>